
import React, { useState, useEffect, useCallback } from "react";
import TableAndSearch from "../common/TableAndSearch";
import { Link } from "react-router-dom";
import { getRequestInService } from "services/axiosServiceBaseClient";
import { encryptWithAES } from "components/common/encyptDecrypt";
import notificationService from "services/notification.service";
import LocalStorageService from "services/tokenlocalstorage.service";

var tempSearch;

export default function Asset(props) {

  const { headerFilter } = props;

  const [listData, setListData] = useState([]);
  const [search, setSearch] = useState("");
  const [totalCount, setTotalCount] = useState(0);

  const fetchAdminListData =  (searchString) => {

    if (
      typeof searchString === "object" ||
      typeof searchString === "undefined" ||
      (typeof searchString === "string" && searchString?.trim().length === 0)
    ) {
    } else {
      localStorage.setItem("lastTableSearch", searchString);
    }

    const headerFilterObj = JSON.parse(
      LocalStorageService.get("headerFilter")
    );

    var query =
      (headerFilterObj?.enterprise
        ? "&enterprise=" + headerFilterObj.enterprise
        : "") +
      (headerFilterObj?.stateId
        ? "&stateId=" + headerFilterObj?.stateId
        : "") +
      (headerFilterObj?.cityId
        ? "&cityId=" + headerFilterObj?.cityId
        : "") +
      (typeof searchString === "object" ||
      typeof searchString === "undefined" ||
      (typeof searchString === "string" && searchString?.trim().length === 0)
        ? ""
        : "&filter=" + encodeURIComponent(searchString));

    query = query ? "?" + query : "";

    try {
      getRequestInService("bss/svc/operator/getall" + query)
        .then((resp) => {
          if (resp?.data && resp?.data != null) {
            const headerFilterListCount = resp?.data?.count ? resp?.data?.count : resp.data.length;
            setListData(resp?.data?.operators);
            // props.assetCount(() => resp?.data?.count);
            // props.assetCount(() =>headerFilterListCount);
            props.userCount(headerFilterListCount);
            setTotalCount(headerFilterListCount)
          }
        })
        .catch((e) => {
          console.log(e, "ERROR");
        });
    } catch (err) {
      // setListData([]);
      notificationService.showNonBlacklistedError(
        "",
        err?.response?.data?.message
      );
      console.error("Error", err);
    }
  };
   

  const getOperatorCount = useCallback(async () => {
    await getRequestInService("bss/svc/operator/count")
      .then((res) => {
        if (res.data != null) {
          props.userCount(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    tempSearch = localStorage.getItem("lastTableSearch");
    if (tempSearch === null) {
      tempSearch = localStorage.setItem("lastTableSearch", "");
      fetchAdminListData();
    } else {
      fetchAdminListData(tempSearch);
    }
  }, []);

  useEffect(() => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    tempSearch = localStorage.getItem("lastTableSearch");
    if (headerFilterObj && Object.keys(headerFilterObj).length > 0) {
      fetchAdminListData(tempSearch);
    }
    if ( headerFilterObj && !headerFilterObj) {
      headerFilter = false;
      setListData([]);
      fetchAdminListData(tempSearch);
    }
  }, [headerFilter]);

  const columns = React.useMemo(() => [
    {
      Header: "Enterprise Name",
      accessor: "enterpriseName",
      width: 163,
    },
    {
      Header: "Operator Name",
      accessor: "username",
      width: 180,
    },
    {
      Header: "Operator Status",
      accessor: "isActive",
      width: 170,
      Cell: (row) => {
        return (
          <>
            {row.value && (
              <div>
                <button
                  style={{
                    cursor: "default",
                    background: "#1A873C",
                    border: "1px",
                    width: "70px",
                    color: "#fff",
                    borderRadius: "5px",
                    margin: "3px 0px 2px 2px",
                    padding: "8px",
                    // margin: "20px 0px 2px 2px",
                  }}
                >
                  Active
                </button>
              </div>
            )}
            {!row.value && (
              <div>
                <button
                  style={{
                    cursor: "default",
                    background: "#C71720",
                    border: "0px",
                    width: "70px",
                    color: "#fff",
                    borderRadius: "5px",
                    margin: "3px 0px 2px 2px",
                    padding: "8px",
                  }}
                >
                  InActive
                </button>
              </div>
            )}
          </>
        );
      },
    },
    {
      Header: "Action",
      accessor: "emailId",
      disableSortBy: true,
      width: 90,
      Cell: (row) => {
        return (
          <>
            <div>
              <Link
                to={`/Users/viewOperator/${row?.row?.original?.id}/view`}
              >
                <img
                  src={require("assets/eye.png").default}
                  style={{ margin: "8px" }}
                ></img>
              </Link>
              <Link
                to={`/Users/updateOperator/${row?.row?.original?.id}`}
              >
                <img src={require("assets/pencil.png").default}></img>
              </Link>
            </div>
          </>
        );
      },
    },
  ]);

  return (
    <div>
      <TableAndSearch
        totalCount= {totalCount}
        searchOpts={{
          onSearch: fetchAdminListData,
          placeholder: "Search by Operator Name",
          setSearch: setSearch
        }}
        columns={columns}
        // data={listData}
        data={listData}
        tigger={props?.tigger}
        tabTemp= {props.tabTemp}
        tempSearch={tempSearch}
        headerFilterParms={headerFilter}
      />
    </div>
  );
}
